import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex h-full w-full items-center justify-center" }

import { ref } from "vue";

import { getIcon, getLocationIconTypes } from "~/js/composables/icons";
import { getLocationColors } from "~/js/composables/colors";

interface Props {
	type: string;
	status: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Marker',
  props: {
    type: {},
    status: {}
  },
  setup(__props: any) {



const colors = ref(getLocationColors());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(['relative block h-5 w-5 rounded-full border border-white', colors.value[__props.status].marker.background])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(`${_unref(getIcon)(_unref(getLocationIconTypes)(__props.type))} ${colors.value[__props.status].marker.text} text-[8px]`)
        }, null, 2)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute left-1/2 top-full -z-10 h-4 w-px -translate-x-1/2 rounded-lg bg-concrete-700" }, null, -1))
    ], 2)
  ]))
}
}

})